// Per Mudassir Jun-19 (Points 7 & 8) the backend renumbered this enum:
// Paid is now 3 and Reject is 4. The `Rejected` key is kept (value 4) so
// existing references stay valid. Finance owns Approved/Paid/Reject.
export const ExpenseManagemnetStatusEnum = Object.freeze({
  Pending: 0,
  Inprocess: 1,
  Approved: 2,
  Paid: 3,
  Rejected: 4,
});

export const ExpenseManagemnetStatusLabel = Object.freeze({
  [ExpenseManagemnetStatusEnum.Pending]: "Pending",
  [ExpenseManagemnetStatusEnum.Inprocess]: "Inprocess",
  [ExpenseManagemnetStatusEnum.Approved]: "Approved",
  [ExpenseManagemnetStatusEnum.Paid]: "Paid",
  [ExpenseManagemnetStatusEnum.Rejected]: "Rejected",
});
